import { PreRegistrationInfoResponseDto } from "@/data/dto/pre-registration-info-response-dto";
import { PreRegistrationPatientInfoEntity } from "@/domain/entity/pre-regitration-patient-info-entity";
import { assertPreRegistrationInfoResponseDto } from "@/utils/validation";

export class PreRegistrationPatientInfoMapper {
  static toEntity(dto: PreRegistrationInfoResponseDto): PreRegistrationPatientInfoEntity {
    // AST 기반 타입 검증
    assertPreRegistrationInfoResponseDto(dto);
    return {
      patient: dto.patient,
      guardian: dto.guardian,
      uuid: dto.uuid,
    };
  }
}
